import styled from 'styled-components';
import { InputNumber as InputNumberAnt } from 'antd';
import { colors } from '@10d/tend-ui-tokens/samolet';

import { disabledStyle } from 'ui/components/Input/styled';

export const InputNumber = styled(InputNumberAnt)`
  border-radius: 8px;
  width: 100%;
  border-color: #bdc5db;
  color: ${colors.gray900};
  overflow: hidden;

  &:hover,
  &:focus,
  &.ant-input-affix-wrapper-focused {
    border-color: ${colors.blue500};
  }

  & .ant-input-number-input::placeholder {
    color: ${colors.gray400};
  }

  &.ant-input-number-disabled {
    ${disabledStyle}
  }
`;

export const WrapperInputNumber = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Styledlabel = styled.label`
  font-size: 12px;
  line-height: 20px;
  color: ${colors.gray900};
`;
